/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import {
  CouponIntput,
  CouponOutput,
  CouponUpdateInput,
  MutationCreateCouponArgs,
} from '../gql/graphql';
import { GET_COUPONS } from '../queries/coupon';
import { CREATE_COUPON, UPDATE_COUPON } from '../mutations/coupon';

export const useGetCoupons = (queries?: CouponOutput) => {
  return useQuery<CouponOutput[], Error>({
    queryKey: ['coupons', queries],
    queryFn: async () => {
      const data = await graphqlFetch<{ getCoupons: CouponOutput[] }, null>(
        GET_COUPONS,
      );
      return data.getCoupons;
    },
  });
};

export const useCreateCoupons = () => {
  const queryClient = useQueryClient();
  return useMutation<CouponOutput, Error, CouponIntput>({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        {
          createCoupon: CouponOutput;
        },
        MutationCreateCouponArgs
      >(CREATE_COUPON, { input });
      return data.createCoupon;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['coupons'],
      }),
  });
};

export const useUpdateCoupons = () => {
  const queryClient = useQueryClient();
  return useMutation<
    CouponUpdateInput,
    Error,
    { input: CouponUpdateInput; updateCouponId: string }
  >({
    mutationFn: async ({ input, updateCouponId }) => {
      const data = await graphqlFetch<
        {
          updateCoupon: CouponUpdateInput;
        },
        // Variables du document ($updateCouponId → arg id du schéma)
        { input: CouponUpdateInput; updateCouponId: string }
      >(UPDATE_COUPON, { input, updateCouponId });
      return data.updateCoupon;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['coupons'],
      }),
  });
};
